import React from "react";

import { useInput } from "../../../hooks/useInput";
import { Checkbox } from "../../../components/Checkbox";
import { useOnChange } from "../../../hooks/useOnChange";
import { InputText } from "../../../components/InputText";
import { InputNumber } from "../../../components/InputNumber";

export const AntennaSystemForm = props => {
    const { index } = props;

    const no = index + 1;
    const antennaSystem = props.antennaSystem === null ? {} : props.antennaSystem;
    const selected = useInput("selected-" + no, antennaSystem.selected);
    const antennaSystemLabel = useInput("antennaSystem-" + no, antennaSystem.antennaSystem);
    const frequency = useInput("frequency-" + no, antennaSystem.frequency);
    const txPower = useInput("txPower-" + no, antennaSystem.txPower);
    const antennaElecDowntilt = useInput("antennaElecDowntilt-" + no, antennaSystem.elecDowntilt);
    const attenuation = useInput("attenuation-" + no, antennaSystem.attenuation);
    const numChannels = useInput("numChannels-" + no, antennaSystem.numChannels);

    useOnChange((name, value) => {
        const [column] = name.split("-");
        if (column === "attenuation" || column === "txPower") {
            antennaSystem[column][0] = value;
        } else {
            antennaSystem[column] = value;
        }
    }, [selected, antennaSystemLabel, frequency, txPower, antennaElecDowntilt, attenuation, numChannels]);


    return (
        <>
            <Checkbox {...selected.bind} title={false} />
            <InputText {...antennaSystemLabel.bind} title={false} fractionDigits={2} />
            <InputNumber {...frequency.bind} title={false} fractionDigits={2} />
            <InputNumber {...txPower.bind} title={false} fractionDigits={2} />
            <InputNumber {...antennaElecDowntilt.bind} title={false} fractionDigits={2} />
            <InputNumber {...attenuation.bind} title={false} fractionDigits={2} />
            <InputNumber {...numChannels.bind} title={false} fractionDigits={0} />
        </>
    );
};